<template>
  <div class="loadedPage">    
    <div class="animationFont">
      <i class="fa fa-spinner loading"></i>
      <p class="remark">玩命加载中...</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    
  },
  mounted(){
  },
  methods: {
  }
}
</script>
<style>
body .loadedPage{
    background: #eee;
}

.loadedPage .animationFont{
  margin-top:50%;
  text-align: center;
}
.loadedPage .loading{    
    width: 24px;
    height: 24px;
    line-height: 24px;
    -webkit-animation: weuiLoading 1s steps(12, end) infinite;
    animation: weuiLoading 1s steps(12, end) infinite;
    font-size: 24px;
    color:#999;
}
.loadedPage .remark{    
    color:#999;
    padding-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/loaded.vue